<template>
    <section class="pad-h-1">
        <div class="rel container pad-v-4 pad-h-1 mrg-v-2">
            <!--遮罩-->
            <matteWidget v-bind="matteData" />

            <h3 class="rel mrg-b-1">
                <span class="fsize-1d5 fsize-1-s">{{about_daas.title}}</span>
            </h3>
            <article class="rel container fsize-1d3 pjustify fsize-1d2-s pad-h-1-s" md>
                <div class="alpha-d6 mrg-b-3 color-yellow fsize-1d2 pcenter">{{about_daas.desc}}</div>
                <list-widget :text-list="about_daas.text_list" />
            </article>
        </div>
    </section>
</template>

<script>
    import matteWidget from "@/components/matte-widget"
    import ListWidget from "@/components/list-widget"

    export default {
        name: "sec-about-daas-widget",
        components: {
            matteWidget,
            ListWidget
        },
        props: ["matteData"],
        data(){
            return {

                //daas 简介
                about_daas: {
                    title: "清华 DaaS 简介",
                    desc: "为大数据应用者赋能",
                    text_list: [
                        "由清华大学信息研究院智库2861项目组权威发布的社会感知大数据库。",
                        "数据服务于所有大数据应用者，面向大数据公司、高校科学院等学术机构、城市规划设计院、地产商和中介、金融、保险、银行等行业。",
                        "清华DaaS业务模式与全国现有大数据应用机构不产生竞争冲突关系，以输出高质量数据为所有大数据应用者赋能助力。"
                    ]
                },

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-about-daas-widget.vue